/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import "cms/utils/init-dayjs";
import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material";
import { SimpliCityContextProvider } from "cms/context";
import { SimpliCityAuthProvider } from "cms/auth/simplicity-auth-context";
import { LoadWebsite } from "cms/shared/load-website";
import { RouterProvider } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { router } from "router/router";
import { Config } from "config";
import { CmsConfig } from "cms/config";
import { Logger } from "cms/utils/logger";
import { theme } from "theme";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { store } from "cms/store";
import { getPackageName, getVersion } from "cms/utils/log/log-helpers";
import { UserWayPlugin } from "cms/integration/userway/userway";
// import { MsalProvider } from "@azure/msal-react";
// import { SkipDuringPrerender } from "cms/shared/hyrdation/avoid-prerender"

import "styles/app-styles";

const SimpliCityApp = (props) => {

    const instance = props?.instance;
    const [error, setError] = useState();
    const [website, setWebsite] = useState();
    const [settings, setSettings] = useState();
    const recaptcha_site_key = Config.recaptcha_site_key || CmsConfig.recaptcha_site_key;

    useEffect(() => {
        // console.log(error)
        if (error) {
            Logger.error(error);
        }
    }, [error]);

    return (
        <ReduxProvider store={store}>
            {/*<MsalProvider instance={instance}>*/}
            <GoogleReCaptchaProvider reCaptchaKey={recaptcha_site_key}>
                <ThemeProvider theme={theme}>
                    <SimpliCityAuthProvider>
                        <LoadWebsite
                            setError={setError}
                            setWebsite={setWebsite}
                            setSettings={setSettings}
                        />
                        {/*  Show an empty skeleton while data is loading  */}
                        {website &&
                            <SimpliCityContextProvider
                                website={website}
                                settings={settings}
                            >
                                {/*   The Router will pass processing context to the   */}
                                {/*   route *element* that matches the request         */}
                                <RouterProvider router={router} />

                            </SimpliCityContextProvider>
                        }
                    </SimpliCityAuthProvider>
                    {/*<SkipDuringPrerender>*/}
                    <UserWayPlugin />
                    {/*</SkipDuringPrerender>*/}
                </ThemeProvider>
            </GoogleReCaptchaProvider>
            {/*</MsalProvider>*/}
        </ReduxProvider>
    );
};
const version = getVersion();
const name = getPackageName();
console.log(`SimpliCity Websites are built by SimpliCity Digital in Canada 🍁. ${name} ${version}`);
SimpliCityApp.displayName = "SimpliCityApp";
export { SimpliCityApp };
